var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51065 3.61239H16.6157C16.9062 3.61239 17.1967 3.35822 17.1967 3.03143V1.57901C17.1967 1.28853 16.9062 0.998047 16.6157 0.998047H1.51065C1.18386 0.998047 0.929688 1.28853 0.929688 1.57901V3.03143C0.929688 3.35822 1.18386 3.61239 1.51065 3.61239ZM1.51065 9.42204H16.6157C16.9062 9.42204 17.1967 9.16787 17.1967 8.84108V7.38867C17.1967 7.09818 16.9062 6.8077 16.6157 6.8077H1.51065C1.18386 6.8077 0.929688 7.09818 0.929688 7.38867V8.84108C0.929688 9.16787 1.18386 9.42204 1.51065 9.42204ZM1.51065 15.2317H16.6157C16.9062 15.2317 17.1967 14.9775 17.1967 14.6507V13.1983C17.1967 12.9078 16.9062 12.6174 16.6157 12.6174H1.51065C1.18386 12.6174 0.929688 12.9078 0.929688 13.1983V14.6507C0.929688 14.9775 1.18386 15.2317 1.51065 15.2317Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.af66f612628a5a3890f1096b168eec0a.svg";
export { ForwardRef as ReactComponent };